import {EncryptionUtil} from '../../shared/utils/encryption.util';
import {Component, OnInit} from '@angular/core';
import 'clientjs';
import {AppConfig} from '../../shared/config/app-config';
import {StringHelper} from './strings.helper';
import {indexDb} from "../../shared/classes/index-db/index-db";
import {ModalService} from "../../lean-shared/components/nz-modal-service/modal.service";
import {NzModalRef} from "ng-zorro-antd/modal";
import { LocalStorageService } from '../services/local-storage.service';
import { StorageKeys } from '../../shared/models/storage-keys';

@Component({
	selector: 'ng-mf-app-device-handler',
	template: '',
})
export class DeviceIdHandlerComponent implements OnInit {
	encryptedDeviceId: string;
	deviceId: any;
	browser: any;
	machineOS: any;
	readonly DeviceUniqueIdentifierID = 1;
	runningModal: NzModalRef;

	constructor(
		private encryptionUtil: EncryptionUtil,
		public config: AppConfig,
		public modalService: ModalService,
    public localStorage: LocalStorageService){
	}

	ngOnInit() {
    console.log('ngOnInit DeviceIdHandlerComponent --->');
	}

	async initializeDeviceIDFromDB(){
    const encryptedDeviceUniqueIdentifierFromDB = await this.getDeviceUniqueIdFromDB();
    const encryptedDeviceUniqueIdentifierNotFoundInDb = StringHelper.isNullOrEmptyOrUndefined(encryptedDeviceUniqueIdentifierFromDB);
    (encryptedDeviceUniqueIdentifierNotFoundInDb) ? await this.handleDeviceIdNotFoundInDb()
    : await this.handleDeviceIdFoundInDb(encryptedDeviceUniqueIdentifierFromDB);
	}

  async handleDeviceIdNotFoundInDb(){
    const deviceUniqueIdentifier = this.getGeneratedDeviceId();
    const encryptedDeviceUniqueIdentifier = this.config.USE_DEVICE_ID_DECRYPTION
      ? this.getEncryptedDeviceId(deviceUniqueIdentifier) :  deviceUniqueIdentifier;
    await this.saveDeviceIdToIndexDb(encryptedDeviceUniqueIdentifier);
    this.setDeviceUniqueIdentifier(deviceUniqueIdentifier, encryptedDeviceUniqueIdentifier);
  }

  async handleDeviceIdFoundInDb(encryptedDeviceUniqueIdentifier: string){
    const validUUID = StringHelper.validUUID(encryptedDeviceUniqueIdentifier);
    const encryptedDeviceId  = validUUID ? encryptedDeviceUniqueIdentifier
      : this.getDecryptedDeviceId(encryptedDeviceUniqueIdentifier);
    if(!this.config.USE_DEVICE_ID_DECRYPTION && !validUUID)
      await this.saveDeviceIdToIndexDb(encryptedDeviceId);
    this.setDeviceUniqueIdentifier(encryptedDeviceId , encryptedDeviceUniqueIdentifier);
  }

	async getDeviceUniqueIdFromDB(){
		const deviceUniqueObj = await indexDb.deviceUniqueId.get(this.DeviceUniqueIdentifierID);
		const deviceUniqueIdentifier = deviceUniqueObj?.deviceUniqueIdentifier;
		const deviceUniqueIdentifierNotFound = StringHelper.isNullOrEmptyOrUndefined(deviceUniqueIdentifier);
		return deviceUniqueIdentifierNotFound ? '' : deviceUniqueIdentifier;
	}

	getEncryptedDeviceId(deviceId: string){
		const deviceIdNotFound = StringHelper.isNullOrEmptyOrUndefined(deviceId);
		if(deviceIdNotFound){
			return '';
		}
    let encryptedDeviceId = '';
    try{
      encryptedDeviceId = this.encryptionUtil.encryptData(deviceId);
    }
    catch (error){
      console.log('failed encryptedDeviceId ', error);
    }
		return encryptedDeviceId;
	}

	getDecryptedDeviceId(deviceId: string){
		const noDeviceIdFound = StringHelper.isNullOrEmptyOrUndefined(deviceId);
		if(noDeviceIdFound){
			return '';
		}
		let decryptData: string;
		try {
			decryptData = this.encryptionUtil.decryptData(deviceId);
		}
		catch (error){
			decryptData = '';
		}
		return StringHelper.isNullOrEmptyOrUndefined(decryptData) ? '' : decryptData;
	}

	setDeviceUniqueIdentifier(deviceUniqueIdentifier: string, encryptedDeviceUniqueIdentifier: string){
		this.deviceId = deviceUniqueIdentifier;
		this.encryptedDeviceId = encryptedDeviceUniqueIdentifier;
    this.localStorage.save(StorageKeys.unique_device_identifier, deviceUniqueIdentifier);
    this.localStorage.save(StorageKeys.encrypted_unique_device_identifier, encryptedDeviceUniqueIdentifier);
	}

	getGeneratedDeviceId(){
		return StringHelper.getUUID();
	}

	async saveDeviceIdToIndexDb(deviceUniqueIdentifier: string){
		const deviceUniqueId = await indexDb.deviceUniqueId.get(1);
		const createNewDeviceUniqueId = StringHelper.isNullOrEmptyOrUndefined(deviceUniqueId);
		createNewDeviceUniqueId ? await indexDb.deviceUniqueId.add({id: 1, deviceUniqueIdentifier})
		: await indexDb.deviceUniqueId.update(this.DeviceUniqueIdentifierID, {deviceUniqueIdentifier});
	}

	async initializeDeviceUniqueIdentifier() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		const client = new ClientJS();
		this.browser = client.getBrowser();
		this.machineOS = client.getOS();
		await this.initializeDeviceIDFromDB();
	}

}
